if ($('footer#footer').length) {
    $('footer#footer').before($('footer#footer .customInstagram'))
    $(".instagram-widget>a").each(function () {
        $(".instagramFeed").append('<div class="igfeed"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>')
    })
}
